// extracted by mini-css-extract-plugin
export default {"range":"styles_range__an1--","input":"styles_input__un9YE","icon":"styles_icon__nTsZp"};